import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Image, Card } from "react-bootstrap";
import { useAuth } from "../AuthContext";
import Carga from "../componentes/cargando/Cargando";
import {Outlet, useNavigate} from "react-router-dom";
import { buscarCategoriaServicio } from "../service/productos/obtenerCategoriasService";
import {
    mensajeError,
    mensajeErrorNoAutorizado,
    mensajeErrorPersonalizado,
    mensajeErrorSesion
} from "../helpers/mensajesSwalError";
import { FaTrashAlt } from "react-icons/fa";
import { useDropzone } from "react-dropzone";
import {guardarProductoServicio} from "../service/productos/guardarProducto";
import {formatearAPesos} from "../helpers/formatos";
import Swal from "sweetalert2";
import {mensajeExitoCargando, mesanjeExitoPersonalizado} from "../helpers/mensajesSwalExito";
import ModalProductosBodegas from "./modalProductosBodegas";
import {buscarBodegasService} from "../service/bodegas/bodegasService";

const FormularioProductos = ({ onSubmit }) => {
    const navigate = useNavigate();
    const { verificacionToken, removerLocalStorage } = useAuth();
    const [cargando, setCargando] = useState(true);
    const [categorias, setCategorias] = useState([]);

    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [listaStockProductos, setListaStockProductos] = useState({
        stockBodegas: []
    });
    const [ bodegas , setBodegas] = useState([]);

    const abrirModalAdd = () => {
        setListaStockProductos(prev => ({
            stockBodegas:
                prev.stockBodegas.length > 0
                    ? prev.stockBodegas
                    : bodegas.map(b => ({
                        bodegaId: b.id,
                        stock: 0
                    }))
        }));

        setModalAddOpen(true);
    };
    const cerrarModalAdd = () => {
        setModalAddOpen(false);
    };

    const [producto, setProducto] = useState({
        nombre: "",
        precio: "",
        descripcion: "",
        categoriaId: "",
        imagenes: []
    });

    const [previewImages, setPreviewImages] = useState([]);

    // -------------------- Cargar Categorías --------------------
    const cargarCategoria = async () => {
        try {
            const categoriasBD = await buscarCategoriaServicio();
            if (!categoriasBD[0]) {
                if (categoriasBD[3] === 401) {
                    removerLocalStorage();
                    mensajeErrorSesion();
                } else if (categoriasBD[3] === 403) {
                    removerLocalStorage();
                    mensajeErrorNoAutorizado();
                } else {
                    removerLocalStorage();
                    mensajeError();
                }
            } else {
                setCategorias(categoriasBD[1]);
            }
        } catch (error) {
            console.error("Error cargando categorías:", error);
            mensajeError();
        } finally {
            setCargando(false);
        }
    };

    const cargarBodegas = async () => {
        const respuesta = await  buscarBodegasService()
        if (!respuesta[0]) {
            if (respuesta[3] === 401) {
                removerLocalStorage();
                mensajeErrorSesion();
            } else if (respuesta[3] === 403) {
                removerLocalStorage();
                mensajeErrorNoAutorizado();
            } else {
                removerLocalStorage();
                mensajeError();
            }
        } else {
            setBodegas(respuesta[1]);
        }
    }

    useEffect(() => {
        verificacionToken("ROLE_DUENO");
        cargarCategoria();
        cargarBodegas();
    }, []);

    const onDrop = (acceptedFiles) => {
        const files = [...producto.imagenes, ...acceptedFiles].slice(0, 5);
        setProducto({ ...producto, imagenes: files });
        const previews = files.map((file) => URL.createObjectURL(file));
        setPreviewImages(previews);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: { "image/*": [] },
        maxFiles: 5
    });

    if (cargando) return <Carga />;

    // -------------------- Handlers --------------------
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProducto({ ...producto, [name]: value });
    };

    const removeImage = (index) => {
        const newFiles = [...producto.imagenes];
        newFiles.splice(index, 1);
        setProducto({ ...producto, imagenes: newFiles });

        const newPreviews = [...previewImages];
        newPreviews.splice(index, 1);
        setPreviewImages(newPreviews);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        Swal.fire({
            title: "Estas seguro?",
            text: "Generar Producto!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Generar!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                mensajeExitoCargando();
                await addProducto();
            }
        });

    };

    const generarNombreUnico = (file) => {
        const parts = file.name.split('.');
        const extension = parts[parts.length - 1].toLowerCase();
        const timestamp = Date.now();
        const random = Math.random().toString(36).substring(2, 10);
        return `${timestamp}-${random}.${extension}`;
    };

    const addProducto = async () => {
        if(producto.categoriaId === 0){
            mensajeErrorPersonalizado('Debes elegir una categoria existente!!!')
            return
        }

        const formData = new FormData(); // ✅ FormData permite enviar archivos
        formData.append("nombre", producto.nombre);
        formData.append("precio", producto.precio);
        formData.append("descripcion", producto.descripcion);
        formData.append("categoriaId", producto.categoriaId);
        formData.append("stockBodegas", JSON.stringify(listaStockProductos));

        // Adjuntar todas las imágenes con nombre único
        producto.imagenes.forEach((file) => {
            const nombreUnico = generarNombreUnico(file);
            formData.append("imagenes", file, nombreUnico);
        });

        const respuesta = await guardarProductoServicio(formData);

        if (respuesta[0]) {
            mesanjeExitoPersonalizado(respuesta[2]);
            navigate("/productos");
        } else {
            if (respuesta[1] === 400) {
                mensajeErrorPersonalizado(respuesta[2]);
            } else if (respuesta[1] === 401) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/no-autorizado");
            } else {
                mensajeErrorPersonalizado(respuesta[2]);
                navigate("/no-encontrado");
            }
        }
    };

    const guardarStockBodega = () => {

    }

    return (
        <Container className="mt-4 pb-5">
            <Card className="shadow-lg border-0">
                <Card.Header
                    className="text-white"
                    style={{
                        background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                        fontWeight: "bold",
                        fontSize: "1.2rem",
                    }}
                >
                    🛍️ Agregar Productos
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Nombre del Producto</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nombre"
                                        value={producto.nombre}
                                        onChange={handleChange}
                                        placeholder="Ingrese el nombre"
                                        required
                                        style={{ borderRadius: "8px" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label>Precio del Producto</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="precio"
                                        value={formatearAPesos(producto.precio)}
                                        onChange={(e) => {
                                            // Extrae solo números del texto ingresado
                                            const soloNumeros = e.target.value.replace(/\D/g, "");
                                            const numero = Number(soloNumeros) || 0;

                                            // Actualiza el estado del producto correctamente
                                            setProducto((prev) => ({
                                                ...prev,
                                                precio: numero,
                                            }));
                                        }}
                                        placeholder={formatearAPesos(1000)}
                                        min="0"
                                        required
                                        style={{ borderRadius: "8px" }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="d-flex flex-column justify-content-end align-items-center">
                                <Form.Group className="w-100 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="edit-btn m-1"
                                        title="Ingresar Stock"
                                        onClick={abrirModalAdd}
                                    >
                                        Ingresar el Stock
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group className="mb-3">
                            <Form.Label>Categoría</Form.Label>
                            <Form.Select
                                name="categoriaId"
                                value={producto.categoriaId}
                                onChange={handleChange}
                                required
                                style={{ borderRadius: "8px" }}
                            >
                                <option value="">Seleccione una categoría</option>
                                {(categorias || []).map((cat) => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.nombre}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Descripción</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="descripcion"
                                value={producto.descripcion}
                                onChange={handleChange}
                                placeholder="Ingrese una descripción"
                                style={{ borderRadius: "8px" }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Imágenes del Producto (máx 5)</Form.Label>
                            <div
                                {...getRootProps()}
                                style={{
                                    border: "2px dashed #d63384",
                                    borderRadius: "8px",
                                    padding: "20px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    backgroundColor: isDragActive ? "#ffe0f0" : "transparent"
                                }}
                            >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <p>Suelta las imágenes aquí...</p>
                                ) : (
                                    <p>Arrastra y suelta tus imágenes o haz click para seleccionarlas</p>
                                )}
                            </div>
                        </Form.Group>

                        {previewImages.length > 0 && (
                            <Row className="mb-3 mt-3">
                                {previewImages.map((img, idx) => (
                                    <Col key={idx} xs={6} md={2} className="mb-2 position-relative">
                                        <Image
                                            src={img}
                                            thumbnail
                                            style={{
                                                width: "100%",
                                                height: "100px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                transition: "0.3s",
                                                cursor: "pointer"
                                            }}
                                            className="hover-zoom"
                                        />
                                        <FaTrashAlt
                                            onClick={() => removeImage(idx)}
                                            style={{
                                                position: "absolute",
                                                top: "5px",
                                                right: "5px",
                                                color: "white",
                                                backgroundColor: "rgba(0,0,0,0.5)",
                                                borderRadius: "50%",
                                                padding: "2px",
                                                cursor: "pointer"
                                            }}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        )}

                        <Button
                            type="submit"
                            className="text-white mt-2"
                            style={{
                                background: "linear-gradient(90deg, #ff9ccf 0%, #d63384 100%)",
                                border: "none",
                                borderRadius: "8px",
                                fontWeight: "bold",
                                padding: "0.6rem 1.2rem",
                                transition: "0.3s",
                            }}
                            onMouseEnter={(e) => e.target.style.filter = "brightness(1.1)"}
                            onMouseLeave={(e) => e.target.style.filter = "brightness(1)"}
                        >
                            Guardar Producto
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
            <Outlet />
            <div>
                <ModalProductosBodegas
                    show={modalAddOpen}
                    onHide={cerrarModalAdd}
                    data={listaStockProductos}
                    setData={setListaStockProductos}
                    bodegas={bodegas}
                    onSave={guardarStockBodega}
                />
            </div>
        </Container>
    );
};

export default FormularioProductos;